<template>
  <section class="spartan-home sp-home">
    <SpartanHeader />

    <div class="container-wide">
      <div class="content">
        <SpartanNavigation />

        <SpartanCarousel />

        <div class="copy">
          <p>
            Whether a small project that doesn’t always fit in a neat little box
            for one type of trade, or a full blown design/build job, Spartan
            Builders brings a blend of hands-on-professionals who do the job
            right. Call Bryant at (682) 551-9674 today.
          </p>
        </div>
      </div>
    </div>

    <SpartanFooter />
  </section>
</template>

<script>
import SpartanHeader from "@/components/SpartanHeader.vue";
import SpartanNavigation from "@/components/SpartanNavigation.vue";
import SpartanCarousel from "@/components/SpartanCarousel.vue";
import SpartanFooter from "@/components/SpartanFooter.vue";

export default {
  name: "SpartanHome",
  components: {
    SpartanHeader,
    SpartanNavigation,
    SpartanCarousel,
    SpartanFooter
  }
};
</script>

<style lang="scss" scoped>
.content {
  background: #7a7a75;
  min-height: 50vh;
}


.section-link {
  text-decoration: none;
}

.section-link:link,
.section-link:visited {
  color: #fff;
}
</style>
